import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { configureApi } from "@safers/api";

import "pretendard/dist/web/variable/pretendardvariable.css";
import { App } from "./App";
import "./styles/globals.css";

const trimmedContextPath = (import.meta.env.VITE_CONTEXT_PATH || "").replace(/^\/+|\/+$/g, "");
const contextPath = trimmedContextPath ? `/${trimmedContextPath}` : "";

configureApi({ baseURL: "/api" });

registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={contextPath || "/"}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
